import { getComputetdMoqForEntityApi, getMoqForEntityApi } from './api';

export const MINIMUM_ORDER_QUANTITY = {
  cacheKey: 'MINIMUM_ORDER_QUANTITY',
  apiFunction: getMoqForEntityApi,
  computedApiFunction: getComputetdMoqForEntityApi
};
